/**
 * Regional Translations Module (French)
 * Matches English structure exactly
 * @module regional
 * @language fr
 */

export const regional = {
  regional: {
    title: "Analyse Régionale",
    subtitle: "Membres actifs par région géographique",
    asiaPacific: "Asie et le Pacifique",
    europe: "Europe",
    americas: "Amérique",
    africaMiddleEast: "Afrique et Moyen-Orient"
  },
  regionalAnalysisPage: {
    pageSubtitle: "1 000+ projets • 148 122 membres • 4 641 Organisations Locales dans 4 régions JCI"
  },
  regionalDistribution: {
    title: "Répartition Régionale",
    subtitle: "1 000+ projets dans 4 régions JCI en 2024-2025",
    totalMembers: "Total des Membres",
    localOrganizations: "Organisations Locales",
    countries: "Pays",
    annualProjects: "Projets Annuels",
    projectDistributionTitle: "Répartition des Projets par Région (2024-2025)",
    projects: "projets",
    risePillarTitle: "Répartition des Piliers JCI RISE",
    total: "Total",
    mentalHealth: "Santé Mentale",
    mentalHealthBeneficiaries: "5,9M+ bénéficiaires touchés",
    workforceResilience: "Résilience de la Main-d'Œuvre",
    workforceDesc: "Compétences et soutien à l'emploi",
    economicRecovery: "Reprise Économique",
    economicDesc: "Entrepreneuriat et croissance économique",
    totalBeneficiaries: "Total des bénéficiaires touchés par 1000+ projets JCI",
    membershipDistributionTitle: "Répartition des Membres par Région",
    fiiScore: "Score FII",
    members: "Membres",
    localOrgs: "Orgs Locales",
    projectShare: "Part des Projets",
    fastest: "Le Plus Rapide",
    emerging: "Émergent",
    stable: "Stable",
    consolidating: "En Consolidation",
    fastestGrowing: "Croissance la Plus Rapide",
    emergingPotential: "Potentiel Émergent",
    sourceNote: "Source: Rapport d'Impact JCI 2025 - Données régionales officielles"
  },
  regionalAnalysis: {
    title: "Analyse Régionale FII",
    subtitle: "Performance régionale de l'Indice d'Impact Futur à travers 114 pays",
    overview: "Aperçu",
    regionalPerformance: "Performance Régionale",
    top5ByRegion: "Top 5 par Région",
    regionalComparison: "Comparaison Régionale",
    fiiScore: "Score FII",
    mentalHealth: "Santé Mentale",
    workforce: "Main-d'Œuvre",
    entrepreneurship: "Entrepreneuriat",
    region: "Région",
    avgScore: "Score Moyen",
    topCountry: "Pays Top",
    gap: "Écart avec Top",
    regionalInsights: "Perspectives Régionales",
    keyStrengths: "Principales Forces",
    challenges: "Défis",
    jciOpportunity: "Opportunité JCI",
    gapBetweenBestWorst: "Écart entre meilleur et pire",
    gapIndicatesInequality: "Cet écart indique une inégalité mondiale significative en matière d'opportunités pour les jeunes",
    bestPerforming: "Meilleure Performance",
    countriesWithData: "Pays avec Données",
    strengths: "Forces",
    europe: {
      name: "Europe",
      strength1: "Systèmes santé mentale les plus forts mondialement",
      strength2: "Investissement élevé dans éducation",
      strength3: "Environnement affaires stable",
      challenge1: "Sud/Est à la traîne des Nordiques",
      challenge2: "Chômage des jeunes en Europe du Sud",
      challenge3: "Réduction de la stigmatisation nécessaire",
      challenge4: "Poches de chômage des jeunes",
      challenge5: "Soutien à l'entrepreneuriat à renforcer",
      opportunity: "Étendre organisations locales haute performance comme modèles; mentorat entrepreneurial"
    },
    asiaPacific: {
      name: "Asie et le Pacifique",
      strength1: "Économies en croissance rapide",
      strength2: "Systèmes éducatifs solides (Asie de l'Est)",
      strength3: "Solutions numériques évolutives",
      challenge1: "Stigmatisation culturelle élevée santé mentale",
      challenge2: "Large variation dans région",
      opportunity: "Approche digital-first; campagnes anti-stigmatisation centrées jeunes"
    },
    americas: {
      name: "Amérique",
      strength1: "Économie forte Amérique du Nord",
      strength2: "Écosystème entrepreneurial croissant",
      strength3: "Adoption télésanté",
      challenge1: "Grands écarts en Amérique latine",
      challenge2: "Inégalité d'accès",
      opportunity: "Projets RISE en Amérique latine; partenariats d'entreprise"
    },
    africaMe: {
      name: "Afrique et Moyen-Orient",
      strength1: "Population la plus jeune",
      strength2: "Haute aspiration entrepreneuriale",
      strength3: "Adoption mobile-first",
      challenge1: "Accès limité santé mentale",
      challenge2: "Chômage des jeunes persistant",
      challenge3: "Écart de financement",
      challenge4: "Données limitées disponibles",
      challenge5: "Seulement 30% formés",
      challenge6: "Besoin de plus de formation",
      opportunity: "Soutien par pairs non clinique; microfinance + mentorat"
    },
    dimensionLeaders: "Leaders par Dimension",
    regionalTrends: "Tendances Régionales",
    expandRegion: "Étendre région"
  },
  mapExplorer: {
    title: "Explorateur de Cartes Interactif",
    subtitle: "Explorer scores FII, adhésion JCI et projets RISE par pays",
    searchCountry: "Rechercher pays...",
    mapView: "Vue Carte",
    filters: "Filtres",
    colorBy: "Colorer par",
    fiiScore: "Score FII",
    mentalHealth: "Santé Mentale",
    workforce: "Main-d'Œuvre",
    entrepreneurship: "Entrepreneuriat",
    jciMembers: "Membres JCI",
    riseProjects: "Projets RISE",
    showOnlyJciCountries: "Afficher uniquement pays JCI",
    membershipThreshold: "Seuil d'Adhésion",
    members: "Membres",
    projects: "Projets",
    selectedCountry: "Pays Sélectionné",
    noCountrySelected: "Aucun pays sélectionné",
    selectCountryFromMap: "Sélectionnez un pays sur la carte pour voir détails",
    fiiRank: "Rang FII",
    of114: "sur 114",
    regionalRank: "Rang Régional",
    memberCount: "Membres JCI",
    noMembership: "Pas d'adhésion JCI",
    projectCount: "Projets RISE",
    active: "Actifs",
    noProjects: "Pas de projets actifs",
    dimensionBreakdown: "Répartition des Dimensions",
    score: "Score",
    recentProjects: "Projets Récents",
    viewDetails: "Voir Détails",
    noProjectsForCountry: "Pas de projets actifs pour ce pays",
    topPerformers: "Meilleurs Performances",
    globalTop10: "Top 10 Mondial",
    regionalTop5: "Top 5 Régional",
    countryDetails: "Détails du Pays",
    jciPresence: "Présence JCI",
    regionalContext: "Contexte Régional",
    compareWith: "Comparer avec",
    global: "Mondial",
    regionalAverage: "Moyenne Régionale",
    insights: "Perspectives",
    downloadData: "Télécharger Données",
    shareMap: "Partager Carte",
    exportImage: "Exporter Image"
  },
  clusterAnalysis: {
    title: "Groupes de Pays FII",
    subtitle: "114 pays regroupés par caractéristiques d'opportunité similaires",
    cluster: "Groupe",
    clusterName: "Nom du Groupe",
    countries: "Pays",
    avgFiiScore: "Score FII Moyen",
    characteristics: "Caractéristiques",
    cluster1: {
      name: "Leaders Mondiaux",
      desc: "Conditions optimales à travers 3 dimensions",
      countries: "13 pays",
      avgScore: "85+",
      examples: "Norvège, Danemark, Suisse"
    },
    cluster2: {
      name: "Économies Haute Performance",
      desc: "Forts dans 2/3 dimensions",
      countries: "22 pays",
      avgScore: "75-85",
      examples: "Allemagne, Australie, Canada"
    },
    cluster3: {
      name: "Marchés Émergents Forts",
      desc: "Croissance rapide mais écarts infrastructure",
      countries: "28 pays",
      avgScore: "60-75",
      examples: "Chili, Malaisie, Pologne"
    },
    cluster4: {
      name: "Régions en Développement",
      desc: "Croissance jeunesse mais défis systèmes",
      countries: "31 pays",
      avgScore: "45-60",
      examples: "Inde, Pérou, Philippines"
    },
    cluster5: {
      name: "Alerte de Crise",
      desc: "Interventions urgentes nécessaires",
      countries: "20 pays",
      avgScore: "<45",
      examples: "Yémen, Tchad, Afghanistan"
    },
    clusterFeatures: "Caractéristiques du Groupe",
    mentalHealthAccess: "Accès SM",
    youthUnemployment: "Chômage Jeunes",
    entrepreneurshipIndex: "Indice Entrepreneurial",
    educationIndex: "Indice Éducatif",
    digitalInfrastructure: "Infrastructure Numérique",
    politicalStability: "Stabilité Politique",
    jciRecommendations: "Recommandations JCI",
    recommendation1: "Étendre programmes RISE dans Groupes 4-5",
    recommendation2: "Répliquer modèles Groupe 1-2 dans régions similaires",
    recommendation3: "Focus santé mentale pour Groupe 3",
    recommendation4: "Partenariats main-d'œuvre partout",
    viewFullClusters: "Voir Analyse Complète Groupes"
  }
} as const;
